import { render, staticRenderFns } from "./GeoArea.vue?vue&type=template&id=63828a0e&"
import script from "./GeoArea.vue?vue&type=script&lang=ts&"
export * from "./GeoArea.vue?vue&type=script&lang=ts&"
import style0 from "./GeoArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports